import React from 'react';

/**
 * Custom candlestick renderer for Recharts. Draws wick + colored body.
 * Placed here so it can be reused/tested independently of the page.
 */
export default function CandlestickBar(props) {
  const { x, y, width, height, low, high, open, close } = props;
  const isBullish = close >= open;
  const color = isBullish ? '#00FF66' : '#FF3366';
  const bodyHeight = Math.abs(close - open) || 0.5;
  const range = high - low || 1;
  const bodyY = y + ((high - Math.max(open, close)) / range) * height;
  const bodyH = (bodyHeight / range) * height;
  const wickX = x + width / 2;

  return (
    <g>
      <line x1={wickX} y1={y} x2={wickX} y2={y + height} stroke={color} strokeWidth={1} />
      <rect x={x + 1} y={bodyY} width={width - 2} height={Math.max(bodyH, 1)} fill={color} stroke={color} />
    </g>
  );
}
